import styled from 'styled-components';

import colors from 'themes/Main';

const { gray02, gray03, success, darkBlue, danger, white } = colors;

export const ButtonContainer = styled.div`
  position: relative;
  width: ${({ width }) =>
    Number.isInteger(width) ? `${width}%` : 'fit-content'};

  &:hover > div {
    visibility: visible;
  }
`;

export const ButtonTooltip = styled.div`
  z-index: 20;
  visibility: hidden;
  width: 200px;
  height: fit-content;
  padding: 16px;
  position: absolute;
  top: ${({ position }) => (position.includes('top') ? '-80px' : '')};
  bottom: ${({ position }) => (position.includes('bottom') ? '-80px' : '')};
  left: ${({ position }) => (position.includes('right') ? '64px' : '')};
  right: ${({ position }) => (position.includes('left') ? '64px' : '')};
  background-color: ${white};
  border-radius: 4px;
  box-shadow: 0px 1px 3px rgba(147, 153, 156, 0.2),
    0px 2px 2px rgba(147, 153, 156, 0.12), 0px 0px 2px rgba(147, 153, 156, 0.14);
`;

export const ButtonTooltipText = styled.p`
  user-select: none;
  margin-bottom: 0;
  font-size: 14px;
  color: ${gray02};
`;

export const Button = styled.button`
  min-width: 140px;
  width: ${({ width }) => (Number.isInteger(width) ? `${width}%` : 'auto')};
  padding: 10px 20px;
  border-radius: 100px !important;
  border: 0;
  transition: all 0.2s ease-in;
  color: ${white};
  font-size: 14px;
  line-height: 100%;
  text-transform: uppercase;
  font-weight: 700;

  &:disabled {
    opacity: 0.15;
  }

  &:hover {
    opacity: 0.65;
  }

  &.cancel-button {
    background-color: ${gray03};
    box-shadow: 0px 1px 3px rgba(147, 153, 156, 0.2),
      0px 2px 2px rgba(147, 153, 156, 0.12),
      0px 0px 2px rgba(147, 153, 156, 0.14);
  }

  &.confirm-button {
    color: ${white};
    background-color: ${success};
    box-shadow: 0px 1px 3px rgba(198, 225, 212, 0.2),
      0px 2px 2px rgba(198, 225, 212, 0.12),
      0px 0px 2px rgba(198, 225, 212, 0.14);
  }

  &.warn-button {
    background-color: ${danger};
    box-shadow: 0px 1px 3px rgba(235, 0, 16, 0.2),
      0px 2px 2px rgba(235, 0, 16, 0.12), 0px 0px 2px rgba(235, 0, 16, 0.14);
  }

  &.default-button {
    background-color: ${darkBlue};
    box-shadow: 0px 1px 3px rgba(0, 169, 255, 0.2),
      0px 2px 2px rgba(0, 169, 255, 0.12), 0px 0px 2px rgba(0, 169, 255, 0.14);
  }
`;
